import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import axios from 'src/app/Service/axios';
import { SafetyRootResponse } from './safety-dashboard.model';
import { SafetyDashboardStore } from './safety-dashboard.store';

export type SafetyTabId = 'overview' | 'speed' | 'risk' | 'quality' | 'table';

interface SafetyTab {
  id: SafetyTabId;
  label: string;
  icon: string;
}

@Component({
  selector: 'app-safety-dashboard',
  templateUrl: './safety-dashboard.component.html',
  styleUrls: ['./safety-dashboard.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SafetyDashboardComponent implements OnInit {
  requestForm: FormGroup = this.FormBuilder.group({
    iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),
    strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),
  });

  activeTab: SafetyTabId = 'overview';

  readonly loading$: Observable<boolean> = this.store.loading$;
  readonly totalVehicles$: Observable<number> = this.store.totalVehicles$;

  tabs: SafetyTab[] = [
    { id: 'overview', label: 'نمای کلی', icon: 'fa-dashboard' },
    { id: 'speed', label: 'تحلیل سرعت', icon: 'fa-tachometer' },
    { id: 'risk', label: 'تحلیل ریسک', icon: 'fa-exclamation-triangle' },
    { id: 'quality', label: 'کیفیت داده', icon: 'fa-shield' },
    { id: 'table', label: 'جدول کامل', icon: 'fa-table' },
  ];

  constructor(
    private _tooltip: NotificationService,
    private FormBuilder: FormBuilder,
    private router: Router,
    private gurdService: GurdServiceService,
    private _otherService: OtherService,
    private store: SafetyDashboardStore
  ) {}

  ngOnInit(): void {
    this.fetchData();
  }

  setActiveTab(tab: SafetyTabId): void {
    this.activeTab = tab;
  }

  refresh(): void {
    this.fetchData();
  }

  trackByTab(_: number, t: SafetyTab): string {
    return t.id;
  }

  async fetchData(): Promise<void> {
    try {
      this.store.setLoading(true);
      const model = this._otherService.stringNumberToNumber(this.requestForm.value);
      const raw = (await axios.post(`MobileHistory_CalculateSafetyIndex`, model)).data;

      let response: any;
      try {
        response = typeof raw === 'string' ? JSON.parse(raw.toString()) : raw;
        if (typeof response === 'string') response = JSON.parse(response);
        if (response && typeof response.data === 'string') {
          try {
            response = JSON.parse(response.data);
          } catch {}
        }
      } catch {
        response = raw;
      }

      if (response?.ISSessionExpired == true) {
        this._tooltip.showError('نشست کاربری شما منقضی شده است');
        this._otherService.removeLocalStorage();
        this.router.navigate(['login'], {
          queryParams: { error: 'MobileHistory_CalculateSafetyIndex' },
        });
        return;
      }

      if (response?.iResult == 0) {
        this._tooltip.showError(response.strError || 'خطا در دریافت اطلاعات');
        return;
      }

      console.log(response)
      const payload: SafetyRootResponse = response;
      this.store.setPayload(payload ?? null);

    } catch (err) {
      console.error('[SafetyDashboard] fetchData error', err);
      this._tooltip.showError('خطا در دریافت اطلاعات داشبورد ایمنی');
    } finally {
      this.store.setLoading(false);
    }
  }
  
}
